export default __webpack_public_path__ + "static/media/inviteSignup1.aa1dd1e8.svg";